module.exports = __webpack_public_path__ + "img/thumb_10.44616964.jpg";